// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f2Hs","colBig":"styles_colBig__3MgPw","colSmall":"styles_colSmall__Zw4V0"};